import { objectWithoutProperties as _objectWithoutProperties } from '../_virtual/_rollupPluginBabelHelpers.js';
import React, { createContext } from 'react';
import PropTypes from 'prop-types';
var _excluded = ["children"];
var ContainerContext = /*#__PURE__*/createContext({});

var ContainerProvider = function ContainerProvider(props) {
  var _props$value = props.value;
  _props$value.children;

  var valueProps = _objectWithoutProperties(_props$value, _excluded); // eslint-disable-line no-unused-vars


  return /*#__PURE__*/React.createElement(ContainerContext.Provider, {
    value: valueProps
  }, props.children);
};

ContainerProvider.displayName = "ContainerProvider";
ContainerProvider.propTypes = {
  children: PropTypes.any,
  value: PropTypes.object
};
export { ContainerContext, ContainerProvider };